// extracted by mini-css-extract-plugin
export default {"main_content":"index_main_content_tfqp5","end":"index_end_LSCFp"};